import api from './api';

export const hl7Service = {
  listMessages: (params) => api.get('/hl7/messages', { params }),
  getMessageById: (id) => api.get(`/hl7/messages/${id}`),
};

export const mwlService = {
  getStatus: () => api.get('/mwl/status'),
  syncNow: () => api.post('/mwl/sync'),
};
